// Deprecated use channel specific components
import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import './product-overview.scss';
import {
  defaultThemeProperties,
  productOverviewDefaultProps,
  productOverviewPropTypes,
  themeProperties
} from './helpers';
import { dataModel } from './dataModel';
import { ProductOverviewDesktop } from './ProductOverviewDesktop';
import { ProductOverviewMobile } from './ProductOverviewMobile';

/** THD ProductOverview component. */
export const ProductOverview = ({
  headingTitle,
  itemId,
  showRichContentsOnly,
  quickLinks,
  hideRichContents,
  preview,
  showReturnMessage,
  revJet
}) => {
  const experienceContext = useContext(ExperienceContext);
  const { channel } = experienceContext;

  if (channel === 'desktop') {
    return (
      <ProductOverviewDesktop
        headingTitle={headingTitle}
        itemId={itemId}
        showRichContentsOnly={showRichContentsOnly}
        quickLinks={quickLinks}
        hideRichContents={hideRichContents}
        preview={preview}
        showReturnMessage={showReturnMessage}
        revJet={revJet}
      />
    );
  }

  return (
    <ProductOverviewMobile
      headingTitle={headingTitle}
      itemId={itemId}
      showRichContentsOnly={showRichContentsOnly}
      quickLinks={quickLinks}
      hideRichContents={hideRichContents}
      preview={preview}
      showReturnMessage={showReturnMessage}
      revJet={revJet}
    />
  );

};

ProductOverview.themeProps = themeProperties;

ProductOverview.defaultThemeProps = defaultThemeProperties;

ProductOverview.displayName = 'ProductOverview';

ProductOverview.dataModel = dataModel;

ProductOverview.propTypes = productOverviewPropTypes;

ProductOverview.defaultProps = productOverviewDefaultProps;
